import React from 'react';
import * as S from './styles';

export interface ClickableAreaProps {
  horizontalExtend?: number;
  verticalExtend?: number;
  children: React.ReactNode;
  className?: string;
}

/**
 * ClickableArea component increases the clickable area of its children
 * by extending it horizontally and vertically.
 *
 * @param horizontalExtend - Number of pixels to extend the clickable area horizontally (left and right)
 * @param verticalExtend - Number of pixels to extend the clickable area vertically (top and bottom)
 * @param children - The element to wrap and extend its clickable area
 * @param className - Additional CSS class names
 */
const ClickableArea: React.FC<ClickableAreaProps> = ({ horizontalExtend = 0, verticalExtend = 0, children, className }) => {
  return (
    <S.ClickableAreaWrapper horizontalExtend={horizontalExtend} verticalExtend={verticalExtend} className={className}>
      {children}
    </S.ClickableAreaWrapper>
  );
};

export default ClickableArea;
